import React from 'react';
import { 
  EditOutlined, 
  PlayCircleOutlined, 
  PauseCircleOutlined, 
  DeleteOutlined,
  ShareAltOutlined,
  DownloadOutlined,
  SettingOutlined,
  EyeOutlined,
  PlusOutlined
} from '@ant-design/icons';
import { CardSectionProps } from '../../../types/compositeCards';

export const CardActions: React.FC<CardSectionProps> = ({
  section,
  card,
  onAction
}) => {
  const { data, context, type } = card;
  const { uiRole, modelType } = context;

  // Get available actions based on card type, UI role, and model type
  const getAvailableActions = () => {
    const actions = [];

    // Common actions
    actions.push({
      id: 'view',
      label: 'View',
      icon: <EyeOutlined />,
      color: '#3b82f6'
    });

    // Role-specific actions
    if (uiRole === 'architect') {
      actions.push({
        id: 'edit',
        label: 'Edit',
        icon: <EditOutlined />,
        color: '#f59e0b'
      });
      actions.push({
        id: 'configure',
        label: 'Configure',
        icon: <SettingOutlined />,
        color: '#8b5cf6'
      });
    }

    if (uiRole === 'operator') {
      actions.push({
        id: 'execute',
        label: 'Execute',
        icon: <PlayCircleOutlined />,
        color: '#10b981'
      });
      actions.push({
        id: 'monitor',
        label: 'Monitor',
        icon: <EyeOutlined />,
        color: '#3b82f6'
      });
    }

    if (uiRole === 'integrator') {
      actions.push({
        id: 'edit',
        label: 'Edit',
        icon: <EditOutlined />,
        color: '#f59e0b'
      });
      actions.push({
        id: 'execute',
        label: 'Execute',
        icon: <PlayCircleOutlined />,
        color: '#10b981'
      });
    }

    // Type-specific actions
    if (type === 'artifact' || type === 'process') {
      actions.push({
        id: 'add_item',
        label: 'Add Item',
        icon: <PlusOutlined />,
        color: '#10b981'
      });
    }

    if (type === 'list') {
      actions.push({
        id: 'filter',
        label: 'Filter',
        icon: <SettingOutlined />,
        color: '#6b7280'
      });
    }

    // Model-specific actions
    if (modelType === 'Prime') {
      actions.push({
        id: 'validate',
        label: 'Validate',
        icon: <SettingOutlined />,
        color: '#8b5cf6'
      });
    }

    if (modelType === 'Company') {
      actions.push({
        id: 'deploy',
        label: 'Deploy',
        icon: <PlayCircleOutlined />,
        color: '#10b981'
      });
    }

    // Additional actions
    actions.push({
      id: 'share',
      label: 'Share',
      icon: <ShareAltOutlined />,
      color: '#6b7280'
    });

    actions.push({
      id: 'export',
      label: 'Export',
      icon: <DownloadOutlined />,
      color: '#6b7280'
    });

    return actions;
  };

  const handleAction = (actionId: string) => {
    onAction?.(actionId, { cardId: card.id, cardType: type });
  };

  const actions = getAvailableActions();

  return (
    <div style={{
      display: 'flex',
      gap: '8px',
      flexWrap: 'wrap',
      padding: '12px',
      backgroundColor: '#f9fafb',
      borderRadius: '8px',
      borderTop: '1px solid #e5e7eb'
    }}>
      {actions.map((action) => (
        <button
          key={action.id}
          onClick={() => handleAction(action.id)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 12px',
            backgroundColor: 'white',
            color: action.color,
            border: `1px solid ${action.color}20`,
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = action.color + '10';
            e.currentTarget.style.borderColor = action.color;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'white';
            e.currentTarget.style.borderColor = action.color + '20';
          }}
          title={action.label}
        >
          {action.icon}
          <span>{action.label}</span>
        </button>
      ))}
    </div>
  );
};
